import { defineStyle } from "@chakra-ui/react";

export const ProgressViewStyles = (width, height) => {
  return {
    globalContainer: defineStyle({
      position: "fixed",
      width: "100%",
      top: "68px",
      left: "0px",
      height: ["50px", "50px", "60px", "60px", "60px", "60px"],
      bg: "#F5F4FA",
      zIndex: 99,
    }),
    mainContainerExecution: defineStyle({
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      // height: ["50px", "50px", "60px", "60px", "60px", "60px"],
      height: "max-content",
      mt: "-20px",
      // mb: ["32px", "32px", "60px", "30px", "20px", "10px"],
      overflow: "auto",
      py: ["6px", "6px", "6px", "6px", "8px", "12px"],
      px: 4,
      backdropFilter: "blur(10px)",
      boxShadow:
        "inset 0px 0px 9px 0px #FFFFFF, inset 0px 9px 18px 0px #FFFFFF",
      position: "fixed",
      top: "90px",
      left: 0,
      zIndex: 100,
    }),

    mainContainerReview: defineStyle({
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      //height: ["50px", "50px", "60px", "60px", "60px", "60px"],
      height: "max-content",
      mt: "-20px",
      mb: ["32px", "32px", "30px", "30px", "20px", "10px"],
      overflow: "auto",
      py: ["6px", "6px", "6px", "6px", "8px", "12px"],
      px: 4,
      backdropFilter: "blur(10px)",
      boxShadow:
        "inset 0px 0px 9px 0px #FFFFFF, inset 0px 9px 18px 0px #FFFFFF",
      position: "fixed",
      top: "90px",
      left: 0,
      zIndex: 100,
    }),
    progressContainer: defineStyle({
      alignItems: "center",
    }),
    leftPaginationNotAllowed: defineStyle({
      cursor: "not-allowed",
      alignItems: "center",
      mr: 4,
    }),
    leftPaginationAllowed: defineStyle({
      cursor: "pointer",
      alignItems: "center",
      mr: 4,
    }),
    paginationIcons: defineStyle({
      width: "15px",
      height: "15px",
    }),
    previousText: defineStyle({
      fontFamily: "Poppins, Text-xs/Regular",
      fontWeight: 400,
      fontSize: { base: "10px", md: "12px", lg: "14px" },
      color: "#291F79",
      ml: "4px",
      mr: 2,
    }),
    previousCountTranslucent: defineStyle({
      fontSize: { base: "12px", md: "14px" },
      display: "flex",
      justifyContent: "center",
      alignItems: "baseline",
      opacity: 0.5,
    }),
    previouseCountOpaque: defineStyle({
      fontSize: { base: "12px", md: "14px" },
      display: "flex",
      justifyContent: "center",
      alignItems: "baseline",
      opacity: 1,
    }),
    progressIconsContainer: defineStyle({
      alignItems: "center",
    }),
    progressIconIndividualContainerLess: defineStyle({
      position: "relative",
      mr: "52px",
    }),
    progressIconIndividualContainerMore: defineStyle({
      position: "relative",
      mr: 0,
    }),
    progressIconBox: defineStyle({
      position: "relative",
      width: width,
      height: height,
      transition: "all 0.2s",
    }),
    progressIcon: defineStyle({
      width: "100%",
      height: "100%",
      position: "absolute",
      zIndex: 10,
    }),
    connectingLineBox: defineStyle({
      position: "absolute",
      top: "50%",
      left: "100%",
      width: "52px",
      height: "4px",
      transform: "translateY(-50%)",
      zIndex: 0,
    }),
    connectingLine: defineStyle({
      position: "absolute",
      width: "100%",
      height: "100%",
    }),
    rightPaginationNotAllowed: defineStyle({
      cursor: "not-allowed",
      alignItems: "center",
      ml: 4,
    }),
    rightPaginationAllowed: defineStyle({
      cursor: "pointer",
      alignItems: "center",
      ml: 4,
    }),
    nextCountTranslucent: defineStyle({
      fontSize: { base: "12px", md: "14px" },
      display: "flex",
      justifyContent: "center",
      alignItems: "baseline",
      opacity: 0.5,
    }),
    nextCountOpaque: defineStyle({
      fontSize: { base: "12px", md: "14px" },
      display: "flex",
      justifyContent: "center",
      alignItems: "baseline",
      opacity: 1,
    }),
    nextText: defineStyle({
      fontFamily: "Poppins",
      fontSize: { base: "10px", md: "12px", lg: "14px" },
      color: "#291F79",
      fontWeight: "400",
      lineHeight: "21px",
      mr: "4px",
    }),
  };
};
